export default __webpack_public_path__ + "static/2-26da1429ca1da30d2efbe0422e678006.jpeg";